export default __webpack_public_path__ + "static/media/tv_error.a9505797.svg";